// extracted by mini-css-extract-plugin
export default {"modalHeader":"Pf_PFLjxS85dAC9l3zLS"};